import { DynamicInputModel, serializable, DynamicFormControlLayout, DynamicInputModelConfig } from '@ng-dynamic-forms/core';
import { BluetoothPrinterItem, BLUETOOTH_PRINTER_CODE_COMPONENT } from '../bluetooth-printer-designer.models';

export enum BT_LABEL_TEXT_STYLE {
	NORMAL = 'NORMAL',
	BOLD = 'BOLD'
}

export interface BtLabelModelConfig extends DynamicInputModelConfig {
	textStyle: BT_LABEL_TEXT_STYLE;
	binding?: string;
}

export class BtLabelModel extends DynamicInputModel {
	@serializable() override readonly type: string = 'bt_label'; 
	textStyle: BT_LABEL_TEXT_STYLE;
	binding?: string;

	constructor(config: BtLabelModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
		this.textStyle = config.textStyle;
		this.binding = config.binding;
	}

	static initModel(_component: BluetoothPrinterItem): BtLabelModel { 
		const formModel = new BtLabelModel({
			id: _component.ID!,
			name: _component.ID,
			label: '',//_component.LABEL,
			value: _component.DEFAULT_VALUE,
			placeholder: _component.PLACEHOLDER,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE,
			textStyle: _component.TEXT_STYLE as BT_LABEL_TEXT_STYLE,
			binding: _component.BINDING,
			additional: _component,
		});
		return formModel;
	}

	static getProperties() {
        return {
            CODE: BLUETOOTH_PRINTER_CODE_COMPONENT.LABEL,
            NAME: 'Label',
            ICON: 'text_fields',
            PROPERTIES: [
                { ID: 'TYPE_COMPONENT', CODE: BLUETOOTH_PRINTER_CODE_COMPONENT.TEXTBOX, LABEL: 'Type', DEFAULT_VALUE: 'Label', IS_READONLY: true },
                { ID: 'INDEX', CODE: BLUETOOTH_PRINTER_CODE_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index' },
                //{ ID: 'DEFAULT_VALUE', CODE: BLUETOOTH_PRINTER_CODE_COMPONENT.TEXTBOX, LABEL: 'Text', DEFAULT_VALUE: 'Text' },
                { ID: 'BINDING', CODE: BLUETOOTH_PRINTER_CODE_COMPONENT.TEXTBOX, LABEL: 'Binding', DEFAULT_VALUE: 'Text' },
                { ID: 'TEXT_STYLE', CODE: BLUETOOTH_PRINTER_CODE_COMPONENT.DROPDOWN, LABEL: 'Style', DS_DATAS: [
                    { ID: 'NORMAL', VALUE: 'Normal' },
                    { ID: 'BOLD', VALUE: 'Bold' },
                ], DS_VALUE_COLUMN_NAME: 'ID', DS_DISPLAY_COLUMN_NAME: 'VALUE', DEFAULT_VALUE: 'NORMAL' },
				{ ID: 'MAX_LENGTH', CODE: BLUETOOTH_PRINTER_CODE_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Longueur (Max)' },
            ]
        };
    }
}